import { ProfessionalsService } from '@/services/ProfessionalsService'
import { Ref, ref } from 'vue'

interface ResponseUseActionsCategory {
  itemData: Ref<any[]>
  read: () => Promise<void>
  save: (data: object) => Promise<any>
  remove: (id: string) => Promise<{ success: boolean }>
  factura_e_active: () => Promise<any>
}

export default function useManProfessionals(): ResponseUseActionsCategory {
  const itemData = ref([])

  const read = async () => {
    const { data } = await new ProfessionalsService().read()
    itemData.value = data
  }

  const factura_e_active = async () => {
    const { data } = await new ProfessionalsService().factura_e_active()
    return data
  }

  const save = async (data: object) => {
    const { id } = data as { id: string }
    if (!id || id === '0') {
      return await new ProfessionalsService().create(data)
    }
    return await new ProfessionalsService().update(data)
  }

  const remove = async (id: string) => {
    const { data } = await new ProfessionalsService().remove(id)
    return {
      success: data.result === 'OK' || data.success === 'OK',
      message: data.exceptionDesc || ''
    }
  }

  return {
    itemData,
    read,
    save,
    remove,
    factura_e_active
  }
}
